
let currentPaginationPage = 1
let canPass = true
const loadItems = async (button,needReturn) => {
	return
	if(canPass || needReturn){
		canPass = false
		currentPaginationPage++
		localStorage.setItem('currentPage', currentPaginationPage);
		const page = localStorage.getItem('currentPage');
		console.log('page: '+ page + '/' + currentPaginationPage)
		const totalPages = parseInt($("[data-total-pages]").val());
		let currentPageScroll = currentPaginationPage + 1;
		let toReturn
		let nextUrl = $("[data-next-url]")
			.val()
			.replace(/page=[0-9]+/, "page=" + currentPaginationPage);
		let nextUrlScroll = $("[data-next-url]")
			.val()
			.replace(/page=[0-9]+/, "page=" + currentPageScroll);
		$("[data-current-page]").val(currentPaginationPage);
      nextUrlScroll = nextUrlScroll.replace(/&phcursor=.*$/, '');
      nextUrl = nextUrl.replace(/&phcursor=.*$/, '');
      console.log(nextUrl)
      

		button.setAttribute("disabled", "");
		button.classList.add("loading");

		await $.ajax({
			url: nextUrl,
			type: "GET",
			dataType: "html",
			success: function (responseHTML) {
				if(!needReturn){
					$(".load-more-grid").append(
						$(responseHTML).find(".load-more-grid").html()
					);
					colorSwatches();
				}
				else{
					toReturn = $(responseHTML).find(".load-more-grid").html()
				}

				// atoms FRONT-WISHLIST-SHOPIFY-01

				if(window.wishlist_parse != null){
					const variant_ids = [];

					window.wishlist_parse.items.forEach(item => {
						variant_ids.push(item.variant_id);
					});

					window.wishlist_buttons = document.querySelectorAll(`[data-wishlist__variant]`);
					window.wishlist_buttons.forEach(button => {
						if (variant_ids.includes(button.dataset.wishlist__variant)) {
							button.dataset.wishlist__active = 'true';
						}
					});
				}

				//
			},
			complete: function () {
				canPass = true
				if (currentPaginationPage <= totalPages) {
					const scollData = document.querySelector(".infinite-scroll__data");
					if (scollData && currentPaginationPage != totalPages) {
						scollData.querySelector("input[data-next-url]").dataset.nextUrl =
							nextUrlScroll;
						scollData.querySelector("input[data-next-url]").value = nextUrlScroll;
						scollData.querySelector(
							"input[data-current-page]"
						).dataset.currentPaginationPage = currentPaginationPage;
						scollData.querySelector("input[data-current-page]").value =
							currentPaginationPage;
						checkVisibility();
					}
					button.removeAttribute("disabled");
					button.classList.remove("loading");
					if (currentPaginationPage == totalPages) {
						button.remove();
					}
				}
			},
		});
		return toReturn
	}
};

const checkVisibility = () => {
	const spinnerList = document.querySelectorAll(".js-infinite-scroll");
	spinnerList.forEach((spinner) => {
		const sectionObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					//loadItems(spinner);
				}
			});
		});

		sectionObserver.observe(spinner);
	});
};

function loadMore() {
	document.querySelectorAll(".js-load-more").forEach((button) => {
		button.onclick = () => {
			loadItems(button);
		};
	});

	checkVisibility();
}

(function () {
	loadMore();
	checkVisibility();
})();
